// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { sendVisitedOnlineCourse } from '../../../apis/onlineCourse';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
const { sendVisitedOnlineCourseActions } = actionCreatorsList;

const outputActions = {
  success: sendVisitedOnlineCourseActions.success,
  failure: sendVisitedOnlineCourseActions.failure
};

type RequestActionTypes = ActionType<
  typeof sendVisitedOnlineCourseActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

const sendVisitedOnlineCourseEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(sendVisitedOnlineCourseActions.request)
    ),
    concatMap((action: RequestActionTypes) => {
      // prepare api params
      const { id } = action.payload;
      // send api promise
      return sendVisitedOnlineCourse(id)
        .then(response => {
          return sendVisitedOnlineCourseActions.success({});
        })
        .catch((error: AxiosError) => {
          // handle error case here
          console.log(error)
          return sendVisitedOnlineCourseActions.failure({ error });
        });
    })
  );
};

export { sendVisitedOnlineCourseEpic as default};
